module.exports = __webpack_public_path__ + "static/media/the-iww-is-coming.aa9215e2.jpg";